import type { FC, ReactNode } from 'react'
import CloseIcon from '../../assets/images/close_rg.svg'
import './styles.css'

interface BaseModalProps {
  isOpen: boolean
  title?: string
  titleIcon?: ReactNode
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
}

const BaseModal: FC<BaseModalProps> = ({ isOpen, title, titleIcon, onClose, children, footer }) => {
  if (!isOpen) return null

  return (
    <div className="overlay">
      <div className="modal-container" role="dialog" aria-modal="true">
        <div className="modal-title-container">
          {titleIcon}
          {title && <h2 className="modal-title">{title}</h2>}
          <button
            type="button"
            className="modal-close-button"
            onClick={onClose}
            aria-label="Close modal"
          >
            <img src={CloseIcon} alt="" aria-hidden="true" className="modal-close-icon" />
          </button>
        </div>

        <div className="modal-content">{children}</div>

        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  )
}

export default BaseModal
